export const addictionMedicine = {
  iconClassSuffix: "addictionmedicine",
  linkText: "Addiction",
  onClickProps: "Addiction Medicine",
};

export const antibiotic = {
  iconClassSuffix: "antibiotic",
  linkText: "Antibiotic",
  onClickProps: "Antibiotic",
};

export const boneandmetabolism = {
  iconClassSuffix: "boneandmetabolism",
  linkText: "Bone and Metabolism",
  onClickProps: "Bone and Metabolism",
};

export const cardiovascular = {
  iconClassSuffix: "cardiovascular",
  linkText: "Cardiovascular",
  onClickProps: "Cardiovascular",
};

export const dermatology = {
  iconClassSuffix: "dermatology",
  linkText: "Dermatology",
  onClickProps: "Dermatology",
};

export const developmentaldisability = {
  iconClassSuffix: "developmentaldisability",
  linkText: "Developmental Disability",
  onClickProps: "Developmental Disability",
};

export const diabetes = {
  iconClassSuffix: "diabetes",
  linkText: "Diabetes",
  onClickProps: "Diabetes",
};

export const fatigue = {
  iconClassSuffix: "fatigue",
  linkText: "Fatigue",
  onClickProps: "Fatigue",
};

export const gastrointestinal = {
  iconClassSuffix: "gastrointestinal",
  linkText: "Gastrointestinal",
  onClickProps: "Gastrointestinal",
};

export const liverdisorders = {
  iconClassSuffix: "liverdisorders",
  linkText: "Liver Disorders",
  onClickProps: "Liver Disorders",
};
export const neurology = {
  iconClassSuffix: "neurology",
  linkText: "Neurology",

  onClickProps: "Neurology",
};
export const oralanddental = {
  iconClassSuffix: "oralanddental",
  linkText: "Oral and Dental",
  onClickProps: "Oral and Dental",
};

export const painandanalgesia = {
  iconClassSuffix: "painandanalgesia",
  linkText: "Pain and Analgesia",

  onClickProps: "Pain and Analgesia",
};

export const palliativecare = {
  iconClassSuffix: "palliativecare",
  linkText: "Palliative Care",

  onClickProps: "Palliative Care",
};

export const psychotropic = {
  iconClassSuffix: "psychotropic",
  linkText: "Psychotropic",
  onClickProps: "Psychotropic",
};

export const respiratory = {
  iconClassSuffix: "respiratory",
  linkText: "Respiratory",
  onClickProps: "Respiratory",
};

export const rheumatology = {
  iconClassSuffix: "rheumatology",
  linkText: "Rheumatology",
  onClickProps: "Rheumatology",
};

export const sexualandreproductivehealth = {
  iconClassSuffix: "sexualandreproductivehealth",
  linkText: "Sexual and Reproductive Health",
  onClickProps: "Sexual and Reproductive Health",
};

export const toxicologyandtoxinology = {
  iconClassSuffix: "toxicologyandtoxinology",
  linkText: "Toxicology and Toxinology",
  onClickProps: "Toxicology and Toxinology",
};

export const ulcerandwoundmanagement = {
  iconClassSuffix: "ulcerandwoundmanagement",
  linkText: "Ulcer and Wound Management",
  onClickProps: "Ulcer and Wound Management",
};

export const wildernessmedicine = {
  iconClassSuffix: "wildernessmedicine",
  linkText: "Wilderness Medicine",
  onClickProps: "Wilderness Medicine",
};

export const quicklinks = {
  iconClassSuffix: "quicklinks",
  linkText: "Pregnancy and Breastfeeding",
  onClickProps: "Pregnancy and Breastfeeding",
}

export const guidelineList = [
  addictionMedicine,
  antibiotic,
  boneandmetabolism,
  cardiovascular,
  dermatology,
  developmentaldisability,
  diabetes,
  fatigue,
  gastrointestinal,
  liverdisorders,
  neurology,
  oralanddental,
  painandanalgesia,
  palliativecare,
  psychotropic,
  respiratory,
  rheumatology,
  sexualandreproductivehealth,
  toxicologyandtoxinology,
  ulcerandwoundmanagement,
  wildernessmedicine,
  quicklinks
];
